/**
 * Chat Rooms Settings Routes - AI Focus
 * Rotas de configuração para Chat Rooms
 */
import { frontendURL } from '../../../../helper/URLHelper';

import ChatRoomsIndex from 'dashboard/components/ChatRooms/settings/Index.vue';
import CreateRoom from 'dashboard/components/ChatRooms/settings/CreateRoom.vue';
import EditRoom from 'dashboard/components/ChatRooms/settings/EditRoom.vue';
import AddMembers from 'dashboard/components/ChatRooms/settings/AddMembers.vue';
import EditMembers from 'dashboard/components/ChatRooms/settings/EditMembers.vue';
import FinishSetup from 'dashboard/components/ChatRooms/settings/FinishSetup.vue';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/chat-rooms'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_chat_rooms_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_chat_rooms_list',
          component: ChatRoomsIndex,
          meta: {
            featureFlag: 'chat_rooms',
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/chat-rooms'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'CHAT_ROOMS_SETTINGS.HEADER',
          icon: 'chat-multiple',
          showBackButton: true,
        };
      },
      children: [
        {
          path: 'new',
          name: 'settings_chat_rooms_new',
          component: CreateRoom,
          meta: {
            featureFlag: 'chat_rooms',
            permissions: ['administrator'],
          },
        },
        {
          path: ':roomId/edit',
          name: 'settings_chat_rooms_edit',
          component: EditRoom,
          meta: {
            featureFlag: 'chat_rooms',
            permissions: ['administrator'],
          },
        },
        {
          path: ':roomId/members',
          name: 'settings_chat_rooms_add_members',
          component: AddMembers,
          meta: {
            featureFlag: 'chat_rooms',
            permissions: ['administrator'],
          },
        },
        {
          path: ':roomId/members/edit',
          name: 'settings_chat_rooms_edit_members',
          component: EditMembers,
          meta: {
            featureFlag: 'chat_rooms',
            permissions: ['administrator'],
          },
        },
        {
          path: ':roomId/finish',
          name: 'settings_chat_rooms_finish',
          component: FinishSetup,
          meta: {
            featureFlag: 'chat_rooms',
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
